import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ProjPicGbagada from "../Components/ProjPicGbagada";

const ProjectPageGbagada = () => {
    return (
        <>
            <Navbar />
            <ProjPicGbagada />
            <Footer />
        </>
    );
};

export default ProjectPageGbagada;
